import { shallowEqual, useSelector } from 'react-redux'

import { Student } from 'app/dataTypes/student'
import Person from 'app/common/classes/person'


export function useStudent(studentID: string) {
  const student = useSelector((state: any) => state.students.data[studentID], shallowEqual)

  if (!student) return null

  const {
    id,
    name,
    gender,
    timezone,
    klass,
    klassId,
    school,
    schoolId,
    accountId,
    splitStudentDayLimit,
  } = student

  return {
    ID: String(id),
    person: new Person({ id, ...name, gender, timezone }),
    classID: klassId ? String(klassId) : null,
    classTitle: klass || null,
    schoolID: schoolId ? String(schoolId) : null,
    schoolTitle: school || null,
    accountID: accountId ? String(accountId) : null,
    splitStudentDayLimit,
  } as Student
}
